<template>
  <div>
    <!-- 销售统计 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务报表</el-breadcrumb-item>
      <el-breadcrumb-item>销售统计</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="tab">
      <span
        v-for="(v,i) in tabBtn"
        :key="v.id"
        @click="tabTitle(i)"
        :class="activeIndex==i?'activeTab':''"
      >{{v.name}}</span>
    </div>
    <el-card>
      <!-- 预定统计 -->
      <div v-if="activeIndex==0">
        <div class="titleSear">
          <el-date-picker
            v-model="valuetime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable
          ></el-date-picker>
          <el-button @click="btn('1')">查询</el-button>
        </div>
        <el-table
          :data="tableData1"
          height="500"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          show-summary :summary-method="getSummaries"
          style="width:100%;overflow-y:auto;margin-top: 20px"
        >
          <el-table-column prop="CreateTime" label="时间" width="180">
            <template slot-scope="scope">
              <!-- {{ scope.row.goods_key }} {{ index }} -->
                <span>{{ scope.row.CreateTime.slice(0,10) }}</span>
            </template>
          </el-table-column>
          <el-table-column  :label="item.ProductName" width="180" v-for="(item,index) in lable1" :key="index">
            <template slot-scope="scope">
              <!-- {{ scope.row.goods_key }} {{ index }} -->
                <span>{{ scope.row.goods_key==index?scope.row.total_Count:0 }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 消费统计 -->
      <div v-if="activeIndex==1">
        <el-row class="conentRow">
          <el-date-picker
            v-model="valuetime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable
          ></el-date-picker>
          <el-select v-model="data2.scenicid" clearable placeholder="全部景区">
            <el-option
              v-for="item in options"
              :key="item.ScenicID"
              :label="item.Name"
              :value="item.ScenicID"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary" @click="btn('2')">查询</el-button>
        </el-row>
        <el-table
          :data="tableData2"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          key="one"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="UseTime" label="日期">
              <template slot-scope="scope">
                <span>{{ scope.row.UseTime.slice(0, scope.row.UseTime.length - 8) }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="scenic_name" label="景区名称"></el-table-column>
          <el-table-column prop="total_sales" label="消费金额"></el-table-column>
          <el-table-column prop="total_use" label="消费数量"></el-table-column>
          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <!-- 没有设计图 -->
              <el-button type="text" @click="xftjDetailFn(scope.row)">明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{data2.total}}条记录，</span>
          <span class="demonstration">当前显示第{{data2.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="data2.total" :current-page="data2.page" @current-change="current2"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 消费统计结束 -->
      <!-- 退票统计开始 -->
      <div v-if="activeIndex==2">
        <el-row class="conentRow">
          <el-date-picker
            v-model="valuetime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <el-select v-model="data3.scenicid" clearable placeholder="全部景区">
            <el-option
              v-for="item in options"
              :key="item.ScenicID"
              :label="item.Name"
              :value="item.ScenicID"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary" @click="btn('3')">查询</el-button>
        </el-row>
        <el-table
          :data="tableData3"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          key="two"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="UseTime" label="日期">
              <template slot-scope="scope">
                <span>{{ scope.row.UseTime.slice(0, scope.row.UseTime.length - 8) }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="scenic_name" label="景区名称"></el-table-column>
          <el-table-column prop="total_use" label="退票数量"></el-table-column>
          <el-table-column prop="total_sales" label="退票金额"></el-table-column>
          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="detailTickFn(scope.row)">明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{data3.total}}条记录，</span>
          <span class="demonstration">当前显示第{{data3.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="data3.total" :current-page="data3.page" @current-change="current3"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 退票统计结束 -->
      <!-- 销售记录开始 -->
      <!-- <div v-if="activeIndex==3">
        <el-row class="conentRow">
          <el-date-picker
            v-model="valuetime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="value" clearable placeholder="全部景区">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary">查询</el-button>
        </el-row>
        <el-table
          :data="tableData4"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          key="three"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="name" label="产品名称"></el-table-column>
          <el-table-column prop="address" label="时间"></el-table-column>
          <el-table-column prop="address" label="总销售额"></el-table-column>
        </el-table>
       
      </div> -->
      <!-- 销售记录结束 -->
      <!-- 消费记录开始 -->
      <!-- <div v-if="activeIndex==4">
        <el-row class="conentRow">
          <el-input placeholder="手机号/订单号/凭证码"></el-input>
          <el-date-picker
            v-model="valuetime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="value" clearable placeholder="全部景区">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-model="value" clearable placeholder="全部产品">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary">查询</el-button>
          <el-button class="conentBtn2" type="primary">导出报表</el-button>
        </el-row>
        <el-table
          :data="tableData5"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          key="four"
          style="width: 100%"
        >
          <el-table-column prop="name" label="验票时间"></el-table-column>
          <el-table-column prop="address" label="景区名称"></el-table-column>
          <el-table-column prop="address" label="产品名称"></el-table-column>
          <el-table-column prop="address" label="订单号"></el-table-column>
          <el-table-column prop="address" label="金额"></el-table-column>
          <el-table-column prop="address" label="数量"></el-table-column>
        </el-table>
      </div> -->
      <!-- 消费记录结束 -->
      <!-- 退票记录开始 -->
      <!-- <div v-if="activeIndex==5">
        <el-row class="conentRow">
          <el-date-picker
            v-model="valuetime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="value" clearable placeholder="全部景区">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-model="value" clearable placeholder="全部产品">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary">查询</el-button>
          <el-button class="conentBtn2" type="primary">导出报表</el-button>
        </el-row>
        <el-table
          :data="tableData6"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          key="five"
          style="width: 100%"
        >
          <el-table-column prop="name" label="退票时间"></el-table-column>
          <el-table-column prop="address" label="景区名称"></el-table-column>
          <el-table-column prop="address" label="产品名称"></el-table-column>
          <el-table-column prop="address" label="订单号"></el-table-column>
          <el-table-column prop="address" label="退票金额"></el-table-column>
          <el-table-column prop="address" label="数量"></el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
      </div> -->
      <!-- 退票记录结束 -->
    </el-card>
    <!-- 销售统计查看详情开始 -->
    <!-- <directStaDialog v-if="xstjinfovisible" ref="xstjinfoDialog"></directStaDialog> -->
    <!-- 销售统计查看详情结束 -->
    <!-- 消费统计明细开始 -->
    <sellStaDialog v-if="detailvisible" ref="detailDialog" @XFRecordClose="CloseXf"></sellStaDialog>
    <!-- 消费统计明细结束 -->
    <!-- 退票统计明细开始 -->
    <sellStaDialog v-if="refundTicketvisible" ref="refundTicketDialog" @TPRecordClose="CloseTp"></sellStaDialog>
    <!-- 退票统计明细结束 -->
  </div>
</template>

<script>
import sellStaDialog from "./dialog/sellStaDialog.vue";
import { getDistributorXSTJ,getDistributorXFTJ,getDistrbutorScenicList,getDistributorTPTJ } from '@/request/distributor.js'
export default {
  components: {
    sellStaDialog
  },
  data() {
    return {
      xstjinfovisible: false, // 销售统计查看详情
      detailvisible: false, // 消费统计明细
      refundTicketvisible: false, // 退票统计明细
      tableData1: [
      ],
      lable1:[],
      tableData2: [
      ],
      tableData3: [
      ],
      tabBtn: [
        {
          id: 1,
          name: "销售统计"
        },
        {
          id: 2,
          name: "核销统计"
        },
        {
          id: 3,
          name: "退票统计"
        },
        // {
        //   id: 4,
        //   name: "销售记录"
        // },
        // {
        //   id: 5,
        //   name: "消费记录"
        // },
        // {
        //   id: 6,
        //   name: "退票记录"
        // }
      ],
      upOption: [
        {
          id: 1,
          value: "是"
        },
        {
          id: 2,
          value: "否"
        }
      ],
      value: "",
      activeIndex: "0", // 选中tab
 
      options: [
      ],
      valuetime: "",
      value: "",
      data1:{
        token:window.sessionStorage.getItem('Token'),
        start:'',
        end:'',
      },
      data2:{
        token:window.sessionStorage.getItem('Token'),
        scenicid:"",
        start:'',
        end:'',
        page_size:8,
        page:1,
        total:1
      },
      data3:{
        token:window.sessionStorage.getItem('Token'),
        scenicid:"",
        start:'',
        end:'',
        page_size:8,
        page:1,
        total:1
      }
    };
  },
  created(){
    this.data1.start = this.GetDateStr(-1)  + ' 00:00:00'
    this.data1.end = this.GetDateStr(0)   + ' 23:59:59'
    this.valuetime = [this.GetDateStr(-1),this.GetDateStr(0)]
    let data = {
      token:window.sessionStorage.getItem('Token'),
    }
    getDistrbutorScenicList(data).then(res=>{
      if(res.data.status=='ok'){
        this.options = res.data.result.data
      }
    })
    this.getList1()
    // this.getList4()
    // this.getList5()
    // this.getList6()
  },
  methods: {
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
            if (index === 0) {
                sums[index] = '合计';
                return;
            } else {
              const values = this.lable1.map(item => item.num);
              // console.log(values)
              values.map((item,i)=>{
                
                  console.log(item,index)
                  sums[i+1] = item
              })
            }
        });
        return sums;
    },
    getNowDate() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      const NOW_MONTHS_AGO = `${year}-${month}-${day}`
      return NOW_MONTHS_AGO
    },
    btn(i){
      if(i=='1'){
        console.log(this.valuetime)
        if(this.valuetime){
          this.data1.start = this.valuetime[0] + ' 00:00:00'
          this.data1.end = this.valuetime[1] + ' 23:59:59'
        }else{
          this.data1.start = ''
          this.data1.end = ''
        }
        this.getList1()
      }else if(i=='2'){
        if(this.valuetime){
          this.data2.start = this.valuetime[0] + ' 00:00:00'
          this.data2.end = this.valuetime[1] + ' 23:59:59'
        }else{
          this.data2.start = ''
          this.data2.end = ''
        }
        this.data2.page=1
        this.getList2()
      }else if(i=='3'){
        if(this.valuetime){
          this.data3.start = this.valuetime[0] + ' 00:00:00'
          this.data3.end = this.valuetime[1] + ' 23:59:59'
        }else{
          this.data3.start = ''
          this.data3.end = ''
        }
        this.data3.page=1
        this.getList3()
      }
    },
    // 消费统计
    getList1(){
      getDistributorXSTJ(this.data1).then(res=>{
        if(res.data.status=='ok'){
          this.tableData1 = []
          res.data.result.goods.map((item,index)=>{
            if(res.data.result.sale.length){
              res.data.result.sale.map((itm,i)=>{
                if(index==itm.goods_key){
                  this.tableData1.push(itm)
                }
              })
            }else{
              for(let i=0;i<1;i++){
                this.tableData1 = [{
                  CreateTime:this.data1.start,
                  total_Count:0,
                  goods_key:0
                }]
              }
            }
          })
          this.lable1 = res.data.result.goods
          this.lable1.map((itm,index)=>{
            itm.num = 0
            this.tableData1.map(item=>{
              if(index==item.goods_key){
          
                itm.num  += Number(item.total_Count)
              }else{
                itm.num  += 0
              }
            })
          })
        }
      })
    },
    // 消费统计
    getList2(){
      getDistributorXFTJ(this.data2).then(res=>{
        if(res.data.status=='ok'){
          this.tableData2 = res.data.result.data
          this.data2.total=res.data.result.total
        }
      })
    },
    //退票统计
    getList3(){
      getDistributorTPTJ(this.data3).then(res=>{
        if(res.data.status=='ok'){
          this.tableData3 = res.data.result.data
          this.data3.total=res.data.result.total
        }
      })
    },
    // 退票统计明细 x
    CloseTp(){
      this.refundTicketvisible = false
    },
    // 消费统计明细
    CloseXf(){
      this.detailvisible = false
    },
    // 退票统计明细
    detailTickFn(row) {
      row.valuetime = this.valuetime
      this.refundTicketvisible = true;
      this.$nextTick(() => {
        this.$refs.refundTicketDialog.detailTick(row);
      });
    },
    // 消费统计明细
    xftjDetailFn(row) {
      row.valuetime = this.valuetime
      this.detailvisible = true;
      this.$nextTick(() => {
        this.$refs.detailDialog.Detail(row);
      });
    },
    // 分页2
    current2(e){
      this.data2.page = e
      this.getList2()
    },
    //分页3
    current3(e){
      this.data3.page = e
      this.getList3()
    },
    tabTitle(index) {
      this.valuetime = ''
      this.activeIndex = index;
      if(index==0){
        this.getList1()
      }else if(index==1){
        this.data2.start = this.GetDateStr(-1)  + ' 00:00:00'
        this.data2.end = this.GetDateStr(0)   + ' 23:59:59'
        this.valuetime = [this.GetDateStr(-1),this.GetDateStr(0)]
        this.getList2()
      }else{
        this.data3.start = this.GetDateStr(-1)  + ' 00:00:00'
        this.data3.end = this.GetDateStr(0)   + ' 23:59:59'
        this.valuetime = [this.GetDateStr(-1),this.GetDateStr(0)]
        this.getList3()
      }
    },
    // 表格合计
   
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    GetDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth()+1;//获取当前月份的日期
      var d = dd.getDate();
      m = (m > 9) ? m : ("0" + m);
      d = (d < 10) ? ("0" + d) : d;
      return y+"-"+m+"-"+d;
    }
  }
};
</script>

<style lang='less' scoped>
.titleSear {
  margin-bottom: 20px;
  .el-input {
    width: 300px;
  }
  .el-date-editor{
    margin-bottom:10px ;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-left: 20px;
  }
}
.conentRow {
  display: flex;
  flex-wrap:wrap ;
  margin-bottom: 20px;
  .el-date-editor {
    margin-right: 20px;
  }
  .el-input {
    width: 250px;
    margin-right: 20px;
  }
  .el-select {
    width: 220px;
    margin-right: 20px;
  }
  .conentBtn {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    border: none;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
  .conentBtn2 {
    width: 120px;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    box-sizing: border-box;
  }
}

.qxsq {
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 30px auto 20px;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}

.tab {
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 0px 0px 4px 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 20px;
  }
}
// /deep/.el-dialog__header {
//   height: 60px;
//   line-height: 60px;
//   padding: 0;
// }

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
/deep/.el-table__footer-wrapper tbody td.el-table__cell,
.el-table__header-wrapper tbody td.el-table__cell {
  background-color: #f5f7fa;
  color: #606266;
  text-align: center;
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}
/deep/ .el-table__body-wrapper{
  height: auto !important;
}

</style>